import { render, staticRenderFns } from "./rec_award_topic.vue?vue&type=template&id=353f4a4c&scoped=true"
import script from "./rec_award_topic.vue?vue&type=script&lang=js"
export * from "./rec_award_topic.vue?vue&type=script&lang=js"
import style0 from "../css/common.less?vue&type=style&index=0&id=353f4a4c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f4a4c",
  null
  
)

export default component.exports